/* global Node */
import { error, trace } from './log';
import { checkCampaign } from './api-client';
import { renderCampaign } from './renderer';
import { getMetadata } from './analytics';
import {componentMap} from './components';

const assertTargetGetElem = (targetIdOrElem) => {
  const target = typeof targetIdOrElem === 'string'
    ? document.getElementById(targetIdOrElem)
    : targetIdOrElem;
  if (!(target instanceof Node)) {
    throw new Error('Invalid target: argument must be an element or an ID string');
  }
  return target;
};

/**
 * Client applications should call this function to indicate when a slot
 * becomes available to be used for marketing purposes.
 * Calling this method will result in a roundtrip to service-marketing, where
 * the server-side logic will decide which (if any) component should be rendered
 * on the target `slot` (container).
 * @param {Node|String} targetIdOrElem the target container
 * @param {Object} slotProps properties of the slot
 */
export const mountSlot = async (targetIdOrElem, slotProps) => {
  trace('mountSlot', slotProps);
  try {
    const target = assertTargetGetElem(targetIdOrElem);
    // call service-marketing/checkCampaign
    const { componentName, props: componentProps, campaignName } = await checkCampaign({
      ...getMetadata(),
      ...slotProps
    });

    renderCampaign({ target, componentName, componentProps, campaignName });
  } catch (err) {
    error(err);
  }
};

/**
 * Render a component on a target container.
 * No tracking - could be used to debug components.
 * @param {Node|String} targetIdOrElem the target container
 * @param {String} componentName the component to be rendered
 * @param {Object} componentProps the props to be passed down for the component
 */
export const loadComponent = (targetIdOrElem, componentName, componentProps) => {
  trace('loadComponent', componentName);
  try {
    const target = assertTargetGetElem(targetIdOrElem);
    renderCampaign({ target, componentName, componentProps, doNotTrack: true });
  } catch (err) {
    error(err);
  }
};

/**
 * TODO
 * @param {Object} slot slot properties
 */
export const unmountSlot = (slot) => {
  trace('unmountSlot', slot);
};

export const preLoadComponent = (componentName) => {
  if (!componentMap[componentName]) {
    return error(`could not find component with name: ${componentName}`);
  }
  componentMap[componentName].preload();
};

export const preLoadAllComponents = () => {
  Object.values(componentMap).map(component => component.preload());
};
